<template>
  <li class="small-12 large-6 cell">
    <a :href="subCategory.url">
      <img v-lazy="subCategory.banner_image" :alt="subCategory.name" width="228" height="140"/>
      <span>{{ subCategory.name }}</span>
    </a>
  </li>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'sub-category-list-item'
  })

  export default class extends Vue {
    @Prop({required: true}) readonly subCategory: object;
  }
</script>
